import { readStored, writeStored } from './persisted.js'

export type Theme = 'auto' | 'light' | 'dark'

interface ListPrefs {
  hideCompleted: boolean
  completedCollapsed: boolean
}

const THEME_KEY = 'streepaf.theme'
const NAME_KEY = 'streepaf.name'
const LIST_PREFS_KEY = 'streepaf.listPrefs'

class Prefs {
  theme = $state<Theme>('auto')
  displayName = $state<string>('')
  private listPrefs = $state<Record<string, ListPrefs>>({})

  init(): void {
    this.theme = readStored<Theme>(THEME_KEY, 'auto')
    this.displayName = readStored<string>(NAME_KEY, '')
    this.listPrefs = readStored<Record<string, ListPrefs>>(LIST_PREFS_KEY, {})
    this.applyTheme()
  }

  setTheme(theme: Theme): void {
    this.theme = theme
    writeStored(THEME_KEY, theme)
    this.applyTheme()
  }

  private applyTheme(): void {
    const root = document.documentElement
    if (this.theme === 'auto') delete root.dataset.theme
    else root.dataset.theme = this.theme
  }

  setName(name: string): void {
    this.displayName = name.trim().slice(0, 50)
    writeStored(NAME_KEY, this.displayName)
  }

  /** Per-list view preferences, keyed by the list's own token. */
  forList(key: string): ListPrefs {
    return this.listPrefs[key] ?? { hideCompleted: false, completedCollapsed: false }
  }

  updateList(key: string, patch: Partial<ListPrefs>): void {
    this.listPrefs = { ...this.listPrefs, [key]: { ...this.forList(key), ...patch } }
    writeStored(LIST_PREFS_KEY, this.listPrefs)
  }
}

export const prefs = new Prefs()
